<template>
  <div class="container mx-auto">
    <el-dialog
      title="TABLA DE RETENCIONES MENSUAL"
      :visible.sync="showISRTable"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="top"
        ref="ISRTableForm"
        :model="ISRTableForm"
        :rules="ISRTableFormRules"
        @submit.native.prevent="saveISRTable('ISRTableForm', ISRTableForm, 1)"
      >
        <el-row :gutter="15" style="margin-bottom: 10px;">
          <el-col :span="6">
            <span>* Nombre</span>
          </el-col>
          <el-col :span="3">
            <span>* Desde</span>
          </el-col>
          <el-col :span="3">
            <span>* Hasta</span>
          </el-col>
          <el-col :span="3">
            <span>* % a Aplicar</span>
          </el-col>
          <el-col :span="3">
            <span>* Sobre</span>
          </el-col>
          <el-col :span="3">
            <span>* Cuota</span>
          </el-col>
        </el-row>
        <el-row :gutter="15" v-for="(item, i) in ISRTableForm.items" :key="i">
          <el-col :span="6">
            <el-form-item
              :prop="`items.${i}.name`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input size="small" v-model="item.name" />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :prop="`items.${i}.from`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input
                size="small"
                v-model="item.from"
                type="number"
                step="0.01"
                min="0.01"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :prop="`items.${i}.until`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input
                size="small"
                v-model="item.until"
                type="number"
                step="0.01"
                min="0.01"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :prop="`items.${i}.percentage`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input
                size="small"
                v-model="item.percentage"
                type="number"
                step="0.01"
                min="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :prop="`items.${i}.applyTo`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input
                size="small"
                v-model="item.applyTo"
                type="number"
                step="0.01"
                min="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :prop="`items.${i}.fixedAmount`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input
                size="small"
                v-model="item.fixedAmount"
                type="number"
                step="0.01"
                min="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-row :gutter="5">
              <el-col
                :span="ISRTableForm.items.length > i + 1 ? 24 : 12"
                v-if="ISRTableForm.items.length > 1"
              >
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  size="small"
                  class="w-full"
                  style="margin-top: 5px;"
                  v-if="ISRTableForm.items.length > 1"
                  @click="removeISRSection(i)"
                />
              </el-col>
              <el-col
                :span="ISRTableForm.items.length == 1 ? 24 : 12"
                v-if="ISRTableForm.items.length == i + 1"
              >
                <el-button
                  type="success"
                  icon="el-icon-plus"
                  size="small"
                  class="w-full"
                  style="margin-top: 5px;"
                  @click="addNewISRSection()"
                />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24" class="flex justify-end">
            <el-button @click="showISRTable = false" size="small"
              >Cancelar</el-button
            >
            <el-button type="primary" native-type="submit" size="small"
              >Guardar</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog
      title="TABLA DE RETENCIONES QUINCENAL"
      :visible.sync="showISRTableQ"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="top"
        ref="ISRTableFormQ"
        :model="ISRTableFormQ"
        :rules="ISRTableFormRules"
        @submit.native.prevent="saveISRTable('ISRTableFormQ', ISRTableFormQ, 2)"
      >
        <el-row :gutter="15" style="margin-bottom: 10px;">
          <el-col :span="6">
            <span>* Nombre</span>
          </el-col>
          <el-col :span="3">
            <span>* Desde</span>
          </el-col>
          <el-col :span="3">
            <span>* Hasta</span>
          </el-col>
          <el-col :span="3">
            <span>* % a Aplicar</span>
          </el-col>
          <el-col :span="3">
            <span>* Sobre</span>
          </el-col>
          <el-col :span="3">
            <span>* Cuota</span>
          </el-col>
        </el-row>
        <el-row :gutter="15" v-for="(item, i) in ISRTableFormQ.items" :key="i">
          <el-col :span="6">
            <el-form-item
              :prop="`items.${i}.name`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input size="small" v-model="item.name" />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :prop="`items.${i}.from`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input
                size="small"
                v-model="item.from"
                type="number"
                step="0.01"
                min="0.01"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :prop="`items.${i}.until`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input
                size="small"
                v-model="item.until"
                type="number"
                step="0.01"
                min="0.01"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :prop="`items.${i}.percentage`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input
                size="small"
                v-model="item.percentage"
                type="number"
                step="0.01"
                min="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :prop="`items.${i}.applyTo`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input
                size="small"
                v-model="item.applyTo"
                type="number"
                step="0.01"
                min="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :prop="`items.${i}.fixedAmount`"
              :rules="[ISRTableFormRules.required]"
            >
              <el-input
                size="small"
                v-model="item.fixedAmount"
                type="number"
                step="0.01"
                min="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-row :gutter="5">
              <el-col
                :span="ISRTableFormQ.items.length > i + 1 ? 24 : 12"
                v-if="ISRTableFormQ.items.length > 1"
              >
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  size="small"
                  class="w-full"
                  style="margin-top: 5px;"
                  v-if="ISRTableFormQ.items.length > 1"
                  @click="removeISRSectionQ(i)"
                />
              </el-col>
              <el-col
                :span="ISRTableFormQ.items.length == 1 ? 24 : 12"
                v-if="ISRTableFormQ.items.length == i + 1"
              >
                <el-button
                  type="success"
                  icon="el-icon-plus"
                  size="small"
                  class="w-full"
                  style="margin-top: 5px;"
                  @click="addNewISRSectionQ()"
                />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24" class="flex justify-end">
            <el-button @click="showISRTableQ = false" size="small"
              >Cancelar</el-button
            >
            <el-button type="primary" native-type="submit" size="small"
              >Guardar</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-row :gutter="15" type="flex" justify="center">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="24" class="mb-5">
            <h3 class="text-l font-semibold">DESCUENTOS DE LEY</h3>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-alert
              :closable="false"
              title="Administración de los descuentos de ley para prestaciones sociales."
              type="info"
              show-icon
            />
          </el-col>
        </el-row>
        <el-tabs v-model="activeTab">
          <el-tab-pane label="Pensiones y Seguridad Social" name="ssp">
            <el-row :gutter="15">
              <el-col :span="12" class="border-r">
                <el-row :gutter="15" class="mb-4">
                  <el-col :span="24" class="flex flex-row items-center">
                    <span class="uppercase font-semibold text-sm"
                      >PENSIONES</span
                    >
                  </el-col>
                </el-row>
                <el-form
                  ref="pensionForm"
                  :model="pensionForm"
                  :rules="pensionFormRules"
                  @submit.prevent.native="
                    savePension('pensionForm', pensionForm)
                  "
                >
                  <el-row :gutter="15" class="mb-2 border-b">
                    <el-col :span="24" class="flex flex-row items-center">
                      <span class="uppercase font-semibold text-xs">AFPS</span>
                    </el-col>
                  </el-row>
                  <el-row :gutter="15">
                    <el-col :span="14">
                      <el-row :gutter="15">
                        <el-col :span="8">
                          <el-form-item label="Patrono (%)" prop="afp.employer">
                            <el-input
                              v-model="pensionForm.afp.employer"
                              size="small"
                              type="number"
                              min="0.01"
                              max="100"
                              step="0.01"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item
                            label="Empleado (%)"
                            prop="afp.employee"
                          >
                            <el-input
                              v-model="pensionForm.afp.employee"
                              size="small"
                              type="number"
                              min="0.01"
                              max="100"
                              step="0.01"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item
                            label="Cant. Máxima"
                            prop="afp.maxAmount"
                          >
                            <el-input
                              v-model="pensionForm.afp.maxAmount"
                              size="small"
                              type="number"
                              min="0.01"
                              step="0.01"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item
                        label="Documento vinculado"
                        prop="afp.documentTypes"
                      >
                        <el-select
                          v-model="pensionForm.afp.documentTypes"
                          placeholder="Seleccionar"
                          clearable
                          multiple
                          filterable
                          default-first-option
                          size="small"
                          class="w-full"
                        >
                          <el-option
                            v-for="document in documentTypes"
                            :key="document.id"
                            :label="document.shortName"
                            :value="document.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="15" class="mb-6">
                    <el-col :span="24" class="flex flex-row items-center">
                      <span>
                        Ej. El total de seguridad social para
                        <span
                          @click="changeSampleAmount('sampleAFP')"
                          class="hover:underline hover:text-blue-700 hover:font-semibold cursor-pointer"
                          >{{ sampleAFP | formatMoney }}</span
                        >
                        será de: Patrono:
                        <span class="font-semibold">{{
                          calcularPensionAfp("sv", sampleAFP, pensionForm.afp)
                            .employer | formatMoney
                        }}</span
                        >, Empleado:
                        <span class="font-semibold">{{
                          calcularPensionAfp("sv", sampleAFP, pensionForm.afp)
                            .employee | formatMoney
                        }}</span>
                      </span>
                    </el-col>
                  </el-row>
                  <el-row :gutter="15" class="mb-2 border-b">
                    <el-col :span="24" class="flex flex-row items-center">
                      <span class="uppercase font-semibold text-xs">IPSFA</span>
                    </el-col>
                  </el-row>
                  <el-row :gutter="15">
                    <el-col :span="14">
                      <el-row :gutter="15">
                        <el-col :span="8">
                          <el-form-item
                            label="Patrono (%)"
                            prop="ipsfa.employer"
                          >
                            <el-input
                              v-model="pensionForm.ipsfa.employer"
                              size="small"
                              type="number"
                              min="0.01"
                              max="100"
                              step="0.01"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item
                            label="Empleado (%)"
                            prop="ipsfa.employee"
                          >
                            <el-input
                              v-model="pensionForm.ipsfa.employee"
                              size="small"
                              type="number"
                              min="0.01"
                              max="100"
                              step="0.01"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item
                            label="Cant. Máxima"
                            prop="afp.maxAmount"
                          >
                            <el-input
                              v-model="pensionForm.ipsfa.maxAmount"
                              size="small"
                              type="number"
                              min="0.01"
                              step="0.01"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item
                        label="Documento vinculado"
                        prop="ipsfa.documentTypes"
                      >
                        <el-select
                          v-model="pensionForm.ipsfa.documentTypes"
                          placeholder="Seleccionar"
                          clearable
                          multiple
                          filterable
                          default-first-option
                          size="small"
                          class="w-full"
                        >
                          <el-option
                            v-for="document in documentTypes"
                            :key="document.id"
                            :label="document.shortName"
                            :value="document.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="15" class="mb-6">
                    <el-col :span="24" class="flex flex-row items-center">
                      <span>
                        Ej. El total de seguridad social para
                        <span
                          @click="changeSampleAmount('sampleIPSFA')"
                          class="hover:underline hover:text-blue-700 hover:font-semibold cursor-pointer"
                          >{{ sampleIPSFA | formatMoney }}</span
                        >
                        será de: Patrono:
                        <span class="font-semibold">{{
                          calcularPensionIpsfa(
                            "sv",
                            sampleIPSFA,
                            pensionForm.ipsfa
                          ).employer | formatMoney
                        }}</span
                        >, Empleado:
                        <span class="font-semibold">{{
                          calcularPensionIpsfa(
                            "sv",
                            sampleIPSFA,
                            pensionForm.ipsfa
                          ).employee | formatMoney
                        }}</span>
                      </span>
                    </el-col>
                  </el-row>
                  <el-row :gutter="15">
                    <el-col
                      :span="24"
                      class="flex flex-row justify-end items-center"
                    >
                      <el-button
                        type="primary"
                        native-type="submit"
                        size="small"
                        >Guardar</el-button
                      >
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
              <el-col :span="12">
                <el-row :gutter="15" style="margin-bottom: 43px;">
                  <el-col :span="24" class="flex flex-row items-center">
                    <span class="uppercase font-semibold text-sm"
                      >SEGURIDAD SOCIAL</span
                    >
                  </el-col>
                </el-row>
                <el-form
                  :model="socialForm"
                  :rules="socialFormRules"
                  ref="socialForm"
                  @submit.prevent.native="saveSocial('socialForm', socialForm)"
                >
                  <el-row :gutter="15">
                    <el-col :span="5">
                      <el-form-item label="Patrono (%)" prop="employer">
                        <el-input
                          v-model="socialForm.employer"
                          size="small"
                          type="number"
                          min="0.25"
                          max="100"
                          step="0.25"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="Empleado (%)" prop="employee">
                        <el-input
                          v-model="socialForm.employee"
                          size="small"
                          type="number"
                          min="0.25"
                          max="100"
                          step="0.25"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="Cant. Máxima" prop="maxAmount">
                        <el-input
                          v-model="socialForm.maxAmount"
                          size="small"
                          type="number"
                          min="0.01"
                          step="0.01"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="9">
                      <el-form-item
                        label="Documento vinculado"
                        prop="documentTypes"
                      >
                        <el-select
                          v-model="socialForm.documentTypes"
                          placeholder="Seleccionar"
                          clearable
                          filterable
                          default-first-option
                          multiple
                          size="small"
                          class="w-full"
                        >
                          <el-option
                            v-for="document in documentTypes"
                            :key="document.id"
                            :label="document.shortName"
                            :value="document.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="15" class="mt-2 mb-4">
                    <el-col
                      :span="24"
                      class="flex flex-row items-center justify-center"
                    >
                      <span>
                        Ej. El total de seguridad social para
                        <span
                          @click="changeSampleAmount('sampleSocial')"
                          class="hover:underline hover:text-blue-700 hover:font-semibold cursor-pointer"
                          >{{ sampleSocial | formatMoney }}</span
                        >
                        será de: Patrono:
                        <span class="font-semibold">{{
                          calcularSocial("sv", sampleSocial, socialForm)
                            .employer | formatMoney
                        }}</span
                        >, Empleado:
                        <span class="font-semibold">{{
                          calcularSocial("sv", sampleSocial, socialForm)
                            .employee | formatMoney
                        }}</span>
                      </span>
                    </el-col>
                  </el-row>
                  <el-row :gutter="15">
                    <el-col
                      :span="24"
                      class="flex flex-row justify-end items-center"
                    >
                      <el-button
                        type="primary"
                        native-type="submit"
                        size="small"
                        >Guardar</el-button
                      >
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="Impuesto Sobre la Renta" name="isr">
            <el-row :gutter="15">
              <el-col :span="12">
                <el-row :gutter="15" class="mb-1">
                  <el-col :span="24" class="flex items-center justify-between">
                    <span class="uppercase font-semibold text-sm"
                      >tabla de retenciones mensual</span
                    >
                    <a
                      href="javascript:;"
                      class="flex justify-end text-xs text-blue-700 hover:underline"
                      @click="openISRTable()"
                      >Modificar tabla</a
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="15" class="mb-2">
                  <el-col :span="24">
                    <el-table :data="formatedISRTable" border size="mini">
                      <el-table-column
                        prop="name"
                        min-width="100"
                      ></el-table-column>
                      <el-table-column
                        prop="from"
                        align="right"
                        label="DESDE"
                        min-width="90"
                      ></el-table-column>
                      <el-table-column
                        prop="until"
                        align="right"
                        label="HASTA"
                        min-width="90"
                      ></el-table-column>
                      <el-table-column
                        prop="percentage"
                        align="center"
                        label="%"
                        min-width="50"
                      ></el-table-column>
                      <el-table-column
                        prop="applyTo"
                        align="right"
                        label="SOBRE"
                        min-width="90"
                      ></el-table-column>
                      <el-table-column
                        prop="fixedAmount"
                        align="right"
                        label="CUOTA FIJA"
                        min-width="90"
                      ></el-table-column>
                    </el-table>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <div class="px-10">
                  <el-row :gutter="15" class="mb-1">
                    <el-col :span="24">
                      <span class="uppercase font-semibold text-sm"
                        >FORMULA para calcular</span
                      >
                    </el-col>
                  </el-row>
                  <el-row :gutter="15">
                    <el-col
                      :span="24"
                      class="flex flex-col justify-center items-center"
                    >
                      <span class="mr-2">
                        Tú formúla luce así:
                        <a
                          href="javascript:;"
                          class="hover:underline hover:text-red-700 text-xs font-semibold"
                          >SALARIO - (PENSION EMP + SEG. SOC. EMP)</a
                        >
                      </span>
                      <span>
                        Ejemplo 1. La renta mensual para
                        <span
                          @click="changeSampleAmount('sampleISR')"
                          class="hover:underline hover:text-blue-700 hover:font-semibold cursor-pointer"
                          >{{ sampleISR | formatMoney }}</span
                        >
                        será de:
                        <span class="font-semibold">{{
                          calcularISR | formatMoney
                        }}</span>
                      </span>
                      <span>
                        Ejemplo 2. La renta quincenal para
                        <span
                          @click="changeSampleAmount('sampleISR')"
                          class="hover:underline hover:text-blue-700 hover:font-semibold cursor-pointer"
                          >{{ sampleISR | formatMoney }}</span
                        >
                        será de:
                        <span class="font-semibold">{{
                          calcularISRQ | formatMoney
                        }}</span>
                      </span>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="mt-2">
              <el-col :span="12">
                <el-row :gutter="15" class="mb-1">
                  <el-col :span="24" class="flex items-center justify-between">
                    <span class="uppercase font-semibold text-sm"
                      >tabla de retenciones quincenal</span
                    >
                    <a
                      href="javascript:;"
                      class="flex justify-end text-xs text-blue-700 hover:underline"
                      @click="openISRTableQ()"
                      >Modificar tabla</a
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="15" class="mb-2">
                  <el-col :span="24">
                    <el-table :data="formatedISRTableQ" border size="mini">
                      <el-table-column
                        prop="name"
                        min-width="100"
                      ></el-table-column>
                      <el-table-column
                        prop="from"
                        align="right"
                        label="DESDE"
                        min-width="90"
                      ></el-table-column>
                      <el-table-column
                        prop="until"
                        align="right"
                        label="HASTA"
                        min-width="90"
                      ></el-table-column>
                      <el-table-column
                        prop="percentage"
                        align="center"
                        label="%"
                        min-width="50"
                      ></el-table-column>
                      <el-table-column
                        prop="applyTo"
                        align="right"
                        label="SOBRE"
                        min-width="90"
                      ></el-table-column>
                      <el-table-column
                        prop="fixedAmount"
                        align="right"
                        label="CUOTA FIJA"
                        min-width="90"
                      ></el-table-column>
                    </el-table>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import * as R from "ramda";
import * as V from "voca";
import {
  inputValidate,
  amountValidate,
  formatMoney,
  calcularSocial,
  calcularPension,
} from "./../../../utils";

export default {
  name: "SettingsActions",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{
          documentTypes( where: { country: 20 } ) {
            id
            name
            shortName
          }
          retirements {
            id
            name
            employer
            employee
            maxAmount
            documentTypes { id }
          }
          socialSecurities {
            id
            employer
            employee
            maxAmount
            documentTypes { id }
          },
          isrRanges { id name from until percentage applyTo fixedAmount paysheetFrecuency { id }}
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) =>
            vm.setData({
              documentTypes: data.documentTypes,
              retirements: data.retirements,
              socialSecurities: data.socialSecurities,
              isrRanges: data.isrRanges,
            })
          );
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      searchValue: "",
      documentTypes: [],
      activeTab: "ssp",
      ISRElements: [
        {
          key: "salary",
          name: "SALARIO",
          type: "success",
        },
        {
          key: "-",
          name: "-",
          type: "info",
        },
        {
          key: "(",
          name: "(",
          type: "info",
        },
        {
          key: "pen_emp",
          name: "PENSION EMP.",
          type: "success",
        },
        {
          key: "+",
          name: "+",
          type: "info",
        },
        {
          key: "soc_emp",
          name: "SEG. SOC. EMP",
          type: "success",
        },
        {
          key: ")",
          name: ")",
          type: "info",
        },
      ],
      showISRTable: false,
      showISRTableQ: false,
      ISRTableForm: {
        items: [
          {
            name: "",
            from: "",
            until: "",
            percentage: "",
            applyTo: "",
            fixedAmount: "",
          },
        ],
      },
      ISRTableFormQ: {
        items: [
          {
            name: "",
            from: "",
            until: "",
            percentage: "",
            applyTo: "",
            fixedAmount: "",
          },
        ],
      },
      ISRTableFormRules: {
        required: {
          required: true,
          message: "Campo requerido",
          trigger: "change",
        },
      },
      ISRTable: [],
      ISRTableQ: [],
      socialForm: {
        employee: "",
        employer: "",
        documentTypes: "",
        maxAmount: "",
      },
      socialFormRules: {
        employee: inputValidate("blur", true),
        employer: inputValidate("blur", true),
        documentTypes: inputValidate("change", true),
        maxAmount: inputValidate("blur", true),
      },
      pensionForm: {
        afp: {
          employee: "",
          employer: "",
          documentTypes: "",
          maxAmount: "",
        },
        ipsfa: {
          employee: "",
          employer: "",
          documentTypes: "",
          maxAmount: "",
        },
      },
      pensionFormRules: {
        afp: {
          employee: inputValidate("blur", true),
          employer: inputValidate("blur", true),
          documentTypes: inputValidate("change", true),
          maxAmount: inputValidate("blur", true),
        },
        ipsfa: {
          employee: inputValidate("blur", true),
          employer: inputValidate("blur", true),
          documentTypes: inputValidate("change", true),
          maxAmount: inputValidate("blur", true),
        },
      },
      sampleISR: 600,
      sampleAFP: 600,
      sampleIPSFA: 600,
      sampleSocial: 600,
    };
  },
  methods: {
    setData({ documentTypes, retirements, socialSecurities, isrRanges }) {
      this.ISRTable = isrRanges.filter((isr) => isr.paysheetFrecuency.id == 1); // Mensual
      this.ISRTableQ = isrRanges.filter((isr) => isr.paysheetFrecuency.id == 2); // Quincenal
      this.documentTypes = documentTypes;

      const afp = retirements.find((r) => r.name === "AFP");
      const ipsfa = retirements.find((r) => r.name === "IPSFA");
      this.pensionForm = {
        afp: {
          employee: !afp ? "" : afp.employee,
          employer: !afp ? "" : afp.employer,
          documentTypes: !afp ? "" : afp.documentTypes.map((dt) => dt.id),
          maxAmount: !afp ? "" : afp.maxAmount,
        },
        ipsfa: {
          employee: !ipsfa ? "" : ipsfa.employee,
          employer: !ipsfa ? "" : ipsfa.employer,
          documentTypes: !ipsfa ? "" : ipsfa.documentTypes.map((dt) => dt.id),
          maxAmount: !ipsfa ? "" : ipsfa.maxAmount,
        },
      };
      this.socialForm = {
        ...socialSecurities[0],
        documentTypes: socialSecurities[0].documentTypes.map((dt) => dt.id),
      };
    },
    changeSampleAmount(id) {
      this.$prompt("", "Cambiar la cantidad", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        inputValue: this[id],
        inputType: "number",
      }).then(({ value }) => {
        this[id] = value;
      });
    },
    addNewISRSection() {
      this.ISRTableForm.items.push({
        name: "",
        from: "",
        until: "",
        percentage: "",
        apllyTo: "",
        fixedAmount: "",
      });
    },
    removeISRSection(index) {
      this.ISRTableForm.items.splice(index, 1);
    },
    addNewISRSectionQ() {
      this.ISRTableFormQ.items.push({
        name: "",
        from: "",
        until: "",
        percentage: "",
        apllyTo: "",
        fixedAmount: "",
      });
    },
    removeISRSectionQ(index) {
      this.ISRTableFormQ.items.splice(index, 1);
    },
    saveISRTable(formName, { items }, type) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.$confirm(
          "¿Estás seguro que deseas actualizar la tabla de retenciones?",
          "Confirmación",
          {
            confirmButtonText: "Si, actualizar",
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                let data = "";
                for (const item in items) {
                  data += `{
                    name: "${items[item].name}",
                    from: ${items[item].from},
                    until: ${items[item].until},
                    percentage: ${items[item].percentage},
                    applyTo: ${items[item].applyTo},
                    fixedAmount: ${items[item].fixedAmount},
                    paysheetFrecuency: ${type}
                  }`;
                }

                axios
                  .post("/", {
                    query: `mutation { isrRangeCreate(data: [${data}]) { id } }`,
                  })
                  .then((res) => {
                    const { data, errors } = res;
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? "Se ha actualizado la tabla de retenciones correctamente"
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = "Si, actualizar";
                    this.ISRTable = items;
                    this.showISRTable = false;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    calcularSocial(country, salary, values) {
      return calcularSocial(
        country,
        values.employer,
        values.employee,
        values.maxAmount,
        salary
      );
    },
    calcularPensionAfp(country, salary, values) {
      return calcularPension(
        country,
        "AFP",
        values.employer,
        values.employee,
        salary,
        values.maxAmount
      );
    },
    calcularPensionIpsfa(country, salary, values) {
      return calcularPension(
        country,
        "IPSFA",
        values.employer,
        values.employee,
        salary,
        values.maxAmount
      );
    },
    savePension(formName, formData) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.$confirm(
          "¿Estás seguro que deseas actualizar la configuracion de las pensiones?",
          "Confirmación",
          {
            confirmButtonText: "Si, actualizar",
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                let data = ``;
                for (const item of Object.keys(formData)) {
                  data += `{
                    name: "${item.toUpperCase()}",
                    employer: ${formData[item].employer},
                    employee: ${formData[item].employee},
                    maxAmount: ${formData[item].maxAmount},
                    documentTypes: ${JSON.stringify(
                      formData[item].documentTypes
                    )}
                  }`;
                }

                axios
                  .post("/", {
                    query: `mutation { retirementSave(data: [${data}]) { id } }`,
                  })
                  .then((res) => {
                    const { data, errors } = res;
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? "Se ha actualizado la configuración de las pensiones correctamente"
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = "Si, actualizar";
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    saveSocial(formName, formData) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.$confirm(
          "¿Estás seguro que deseas actualizar la configuracion de la seguridad social?",
          "Confirmación",
          {
            confirmButtonText: "Si, actualizar",
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                let data = `{
                  employer: ${formData.employer},
                  employee: ${formData.employee},
                  maxAmount: ${formData.maxAmount},
                  documentTypes: ${JSON.stringify(formData.documentTypes)}
                }`;

                axios
                  .post("/", {
                    query: `mutation { socialSecuritySave(data: ${data}) { id } }`,
                  })
                  .then((res) => {
                    const { data, errors } = res;
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? "Se ha actualizado la configuración de la seguridad social correctamente"
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = "Si, actualizar";
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    openISRTable() {
      this.showISRTable = true;
      const items =
        this.ISRTable.length > 0
          ? [...this.ISRTable]
          : [
              {
                name: "",
                from: "",
                until: "",
                percentage: "",
                applyTo: "",
                fixedAmount: "",
              },
            ];
      this.ISRTableForm["items"] = items;
    },
    openISRTableQ() {
      this.showISRTableQ = true;
      const items =
        this.ISRTableQ.length > 0
          ? [...this.ISRTableQ]
          : [
              {
                name: "",
                from: "",
                until: "",
                percentage: "",
                applyTo: "",
                fixedAmount: "",
              },
            ];
      this.ISRTableFormQ["items"] = items;
    },
  },
  computed: {
    formatedISRTable() {
      return this.ISRTable.map((e) => {
        const from = formatMoney(e.from);
        const until = formatMoney(e.until);
        const percentage = `${e.percentage}%`;
        const applyTo = formatMoney(e.applyTo);
        const fixedAmount = formatMoney(e.fixedAmount);
        return {
          ...e,
          from,
          until,
          percentage,
          applyTo,
          fixedAmount,
        };
      });
    },
    formatedISRTableQ() {
      return this.ISRTableQ.map((e) => {
        const from = formatMoney(e.from);
        const until = formatMoney(e.until);
        const percentage = `${e.percentage}%`;
        const applyTo = formatMoney(e.applyTo);
        const fixedAmount = formatMoney(e.fixedAmount);
        return {
          ...e,
          from,
          until,
          percentage,
          applyTo,
          fixedAmount,
        };
      });
    },
    calcularISR() {
      let formula = "";
      const salary = parseFloat(this.sampleISR);
      for (const e of this.ISRElements) {
        switch (e.key) {
          case "salary":
            formula += salary;
            break;
          case "pen_emp":
            formula +=
              (parseFloat(this.pensionForm.afp.employee) * salary) / 100;
            break;
          case "soc_emp":
            formula += (parseFloat(this.socialForm.employee) * salary) / 100;
            break;
          default:
            formula += e.key;
            break;
        }
      }

      // Encuentra la cantidad aplicable
      const aplicable = eval(formula);

      // Se aplica la tabla a lo apliable
      const range = this.ISRTable.find((t) => {
        return aplicable >= t.from && aplicable <= t.until;
      });

      if (range != null) {
        return (
          (aplicable - range.applyTo) * (range.percentage / 100) +
          parseFloat(range.fixedAmount)
        );
      } else {
        return 0;
      }
    },
    calcularISRQ() {
      let formula = "";
      const salary = parseFloat(this.sampleISR) / 2;
      for (const e of this.ISRElements) {
        switch (e.key) {
          case "salary":
            formula += salary;
            break;
          case "pen_emp":
            formula +=
              (parseFloat(this.pensionForm.afp.employee) * salary) / 100;
            break;
          case "soc_emp":
            formula += (parseFloat(this.socialForm.employee) * salary) / 100;
            break;
          default:
            formula += e.key;
            break;
        }
      }

      // Encuentra la cantidad aplicable
      const aplicable = eval(formula);

      // Se aplica la tabla a lo apliable
      const range = this.ISRTableQ.find((t) => {
        return aplicable >= t.from && aplicable <= t.until;
      });

      if (range != null) {
        return (
          (aplicable - range.applyTo) * (range.percentage / 100) +
          parseFloat(range.fixedAmount)
        );
      } else {
        return 0;
      }
    },
  },
};
</script>
